import { format } from "date-fns";

export const getErrorMessage = (err) => {
  if (
    err?.response?.data?.errors &&
    Array.isArray(err?.response?.data?.errors)
  ) {
    // If errors array is present, join the error messages
    return err?.response?.data?.errors?.map((element) => element);
  }
  // Otherwise, use the general error message
  return err?.response?.data?.message || err.message;
};

export function fDateTime(date, newFormat) {
  const fm = newFormat || "dd MMM yyyy";
  if (date == null || date === "") return "";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return format(d, fm);
  } catch {
    return "";
  }
}

export function fDateMonth(dateStr) {
  const date = new Date(dateStr);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const month = months[date.getMonth()];
  const year = date.getFullYear();

  const formattedDate = `${month} ${year}`;
  return formattedDate;
}

export function fTime(date, newFormat) {
  const fm = newFormat || "p";
  if (date == null || date === "") return "";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) {
    if (typeof date === "string" && /^\d{1,2}:\d{2}/.test(date.trim())) return date.trim();
    return "";
  }
  try {
    return format(d, fm);
  } catch {
    return "";
  }
}
